import "./NoticeBox.css";
import { AlertTriangle, CheckCircle, Info, Lightbulb } from "./icons";

const defaultIcons = {
  warning: AlertTriangle,
  success: CheckCircle,
  info: Info,
  tip: Lightbulb,
  primary: Info,
  neutral: Info,
  danger: AlertTriangle,
};

const NoticeBox = ({
  title,
  children,
  variant = "warning",
  size = "md",
  icon: Icon,
  iconSize = 18,
  bordered = false,
  hoverable = false,
  animation = "",
  className = "",
}) => {
  const NoticeIcon = Icon || defaultIcons[variant] || Info;

  return (
    <div
      className={`ui-notice-box ${variant} ${size} ${
        bordered ? "bordered" : ""
      } ${hoverable ? "hoverable" : ""} ${animation} ${className}`}
    >
      <span className="ui-notice-icon">
        <NoticeIcon size={iconSize} />
      </span>

      <div className="ui-notice-content">
        {title && <div className="ui-notice-title">{title}</div>}
        {children && <div className="ui-notice-body">{children}</div>}
      </div>
    </div>
  );
};

export default NoticeBox;
